<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasTradeStatusType="true"
      :hasReportSourceType="true"
      :hasFoodStatusType="true"
      :hasCostType="true"
      :hasStore="true"
      :hasEmployee="true"
      :hasFoodMajorKind="true"
      :hasFoodKind="true"
      :hasFood="true"
      :hasTerminal="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
    >
    </condition-part>
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
      columns: [
        { name: "TerminalNumber" },
        { name: "TerminalName" },
        { name: "SalNumber" },
        { name: "TradeType" },
        { name: "EmployeeNumber" },
        { name: "EmployeeName" },
        { name: "SalerNumber" },
        { name: "SalerName" },
        { name: "SalTime" },
        { name: "FoodNumber" },
        { name: "FoodName" },
        { name: "Qty" },
        { name: "Unit" },
        { name: "SalPrice" },
        { name: "Total" },
        { name: "TotalCost" },
        { name: "GrossProfit" },
        { name: "GrossMargin" },
      ],
    };
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getSaleProfit(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getSaleProfit(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printSaleProfit(condition);
    },
    getItems(condition) {
      const vm = this;
      this.$api.reports.getSaleProfit(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
